export const IS_STAGING =
  process.env.NEXT_PUBLIC_ENV === "staging" ||
  process.env.NODE_ENV === "development";

export const IS_PRODUCTION = !IS_STAGING;
